import { type AppConfigurationSection } from 'graphql/models/extended';
import { type ConfigurationSection } from 'graphql/models/generated';
import { type SelectorSection } from 'graphql/models/product-selector.model';

/**
 * Taken 1:1 from offer-section service, note that only
 * `{ showProp: null | { valueText: 'true' } } | {}` will yield `true`.
 *
 * @example isSectionVisible({ showProp: null }) // => true
 * @example isSectionVisible({ showProp: { valueText: 'true' } }) // => true
 * @example isSectionVisible({ showProp: undefined }) // => false
 * @example isSectionVisible({ showProp: "anything else" }) // => false
 * @example isSectionVisible({}) // => true
 */
export function isSectionVisible(section: AppConfigurationSection | SelectorSection | ConfigurationSection): boolean {
  if (!('showProp' in section) || section.showProp === null) {
    return true;
  }

  return Boolean(
    section.showProp && section.showProp.valueText
    && section.showProp.valueText.toLowerCase() === 'true'
  );
}

export function isFilterSectionVisible(section: AppConfigurationSection | SelectorSection | ConfigurationSection): boolean {
  if (!('showFilterProp' in section) || section.showFilterProp === null) {
    return false;
  }

  return Boolean(section?.showFilterProp?.valueText?.toLowerCase() === 'true');
}
